import React from "react";
import Container from "./Container";
import { NavLink } from "react-router-dom";

const Cta = () => {
  return (
    <section className="py-12 lg:py-16">
      <Container>
        <div className="relative overflow-hidden rounded-2xl bg-slate-900 px-6 py-10 text-white shadow-xl sm:px-8 lg:px-12 lg:py-12">
          <div className="absolute right-0 top-0 h-48 w-48 translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-500/20 blur-3xl" />
          <div className="relative flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="max-w-xl">
              <h2 className="text-xl font-bold tracking-tight sm:text-2xl lg:text-3xl">
                Stop bidding. Start responding.
              </h2>
              <p className="mt-2 text-sm text-slate-300 sm:text-base lg:text-lg">
                Join 400+ freelancers. No credit card. Set up in 2 minutes.
              </p>
            </div>
            <NavLink
              to="/signup"
              className="inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-white px-6 py-3.5 text-base font-semibold text-slate-900 shadow-lg transition hover:bg-slate-100"
            >
              Get started free
            </NavLink>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Cta;
